import { useDispatch, useSelector } from 'react-redux';

import Dropdown from 'atoms/dropdown';
import ImageUploader from 'atoms/image-uploader';
import Input from 'atoms/input';
import {
  editForm,
  setAddAllState,
  setAllServices,
} from 'store/reducers/groomerForm';
import { catAndDogTypeId } from 'util/constants';

import { defaultService } from '../GroomerEdit';

export default function Details({ saveImage }) {
  const dispatch = useDispatch();
  const { type: animalTypes } = useSelector((state) => state.main.core);
  const countryIdOptions = useSelector((state) => state.main.geo.countryCode);
  const {
    servicedAnimals,
    firstName,
    lastName,
    phone,
    email,
    countryCodeId,
    links,
  } = useSelector((state) => state.groomerForm);

  return (
    <div className="groomer-drawer-details border-light-purple p-24 radius-24">
      <h4 className="mb-8">Groomer details</h4>
      <ImageUploader
        avatar={links?.image && links.image.desktop.small}
        size="small"
        saveImage={saveImage}
        showChangeImageText
        textPosition="right"
        fileName="upload_file"
      />
      <div className="flex-row mt-15">
        <Input
          className="mr-10"
          placeholder="First name"
          size="small"
          variant="white"
          onChange={(value) => dispatch(editForm({ key: 'firstName', value }))}
          value={firstName}
        />
        <Input
          placeholder="Last name"
          size="small"
          variant="white"
          onChange={(value) => dispatch(editForm({ key: 'lastName', value }))}
          value={lastName}
        />
      </div>
      <div className="flex-row">
        <Dropdown
          id="countryCode"
          size="small"
          variant="white"
          className="mb-15 mr-10 country-code-container"
          items={countryIdOptions}
          onClick={(value) =>
            dispatch(editForm({ key: 'countryCodeId', value }))
          }
          value={countryCodeId}
        />
        <Input
          placeholder="Phone number"
          size="small"
          variant="white"
          onChange={(value) => dispatch(editForm({ key: 'phone', value }))}
          value={phone}
        />
      </div>
      <Input
        placeholder="Email"
        type="email"
        size="small"
        variant="white"
        onChange={(value) => dispatch(editForm({ key: 'email', value }))}
        value={email}
      />
      <Dropdown
        size="small"
        variant="white"
        id="animals"
        placeholder="Animals serviced"
        items={[
          ...animalTypes,
          { id: catAndDogTypeId, value: 'Both (Dogs, Cats)' },
        ]}
        selectedItems={servicedAnimals}
        value={servicedAnimals?.[0]?.value}
        onClick={(value) => {
          if (value.id !== servicedAnimals[0]?.id) {
            dispatch(editForm({ key: 'servicedAnimals', value: [value] }));
            dispatch(setAllServices(defaultService));
            dispatch(setAddAllState(false));
          }
        }}
      />
    </div>
  );
}
